import React from 'react';
import styled from 'astroturf/react';
import LightbulbIcon from 'js/design_system/icons/lightbulb_filled.svg';

const BadgeContainer = styled.div`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 4px;
  padding: 0 8px;
  height: 28px;
  background-color: #edf4f4;
  border: 1px solid #d4e6e6;
  border-radius: 8px;
`;

const BadgeText = styled.span`
  font-family: var(--type-font-family-sans-serif, 'DM Sans');
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #164c50;
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  svg {
    fill: #164c50;
    stroke: #164c50;
    width: 16px;
    height: 16px;
  }
`;

/**
 * A badge component to indicate a recommended podcast in the podcast library.
 * Uses turquoise styling with a lightbulb icon to match the Figma design.
 */
export const RecommendedPodcastBadge: React.FC = () => {
  return (
    <BadgeContainer>
      <IconWrapper>
        <LightbulbIcon />
      </IconWrapper>
      <BadgeText>Recommended podcast</BadgeText>
    </BadgeContainer>
  );
};
